import React from "react";
import { CrmNumberCounter } from "../../utils/CrmNumberCounter";
import ProgressBarBs from "../ProgressBarBs/ProgressBarBs";

const CrmArraySort = ({ payload, type, sort, color, feature }) => {
  let array = [];

  const arraysort = !type
    ? payload?.map((item) => {
        const data = item?.split("x:");

        array.push({
          name: data[1],
          count: data[2],
        });

        return array.sort((a, b) => b.count - a.count);
      })
    : payload?.map((item) => {
        const data = item?.split("x:");
        array.push({
          name: data[1],
          count: feature
            ? (
                parseInt(data[2]) +
                parseInt(data[4]) -
                parseInt(data[6])
              ).toLocaleString()
            : (parseInt(data[2]) + parseInt(data[4])).toLocaleString(),
          price: feature
            ? (
                parseInt(data[3]) +
                parseInt(data[5]) -
                parseInt(data[7])
              ).toLocaleString()
            : (parseInt(data[3]) + parseInt(data[5])).toLocaleString(),
          rawPrice: parseInt(data[3]) + parseInt(data[5]),
        });

        return array.sort((a, b) => b.rawPrice - a.rawPrice);
      });

  const Data = array?.map((item, index) => {
    return (
      <>
        {item?.name ? (
          <ProgressBarBs
            key={index}
            label={`${item.name} - ${
              !type
                ? item.count + " عدد"
                : sort === false
                ? item.price + " تومان"
                : item.count + " عدد"
            }`}
            percentage={
              (!type ? item.count : item.price) == "0"
                ? "0"
                : (item.count * 100) / CrmNumberCounter(payload)
            }
            color={color}
          />
        ) : (
          ""
        )}
      </>
    );
  });
  return Data;
};

export default CrmArraySort;
